<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
html,
body {
  height: 100%;
  padding: 0;
  margin: 0;
}

#app {
  height: 100%;
}

.el-dialog__header {
  background-color: #303133;
  padding-bottom: 15px !important;
}

.el-dialog__title {
  color: #fff;
}

.el-dialog__body {
  padding-bottom: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue